import { defaultTo } from "lodash";
import { DateTime } from "luxon";
import { Model } from "../Model";

export interface IHospitalScheduleRequestModel extends Model {
    hospitalScheduleId: number;
    veterinarianId: number | undefined;
    hospitalScheduleTemplateId: number | undefined;
    hospitalId: number
    date: string;
}

export class HospitalScheduleRequestModel implements IHospitalScheduleRequestModel {
    hospitalScheduleId: number;
    veterinarianId: number | undefined;
    hospitalScheduleTemplateId: number | undefined;
    hospitalId: number
    date: string;
    isAdHoc: boolean;
    rowVersion: string;



    constructor(params?: Partial<IHospitalScheduleRequestModel>) {
        this.hospitalScheduleId = defaultTo(params?.hospitalScheduleId, 0);
        this.veterinarianId = defaultTo(params?.veterinarianId, undefined);
        this.hospitalScheduleTemplateId = defaultTo(params?.hospitalScheduleTemplateId, undefined);
        this.hospitalId = defaultTo(params?.hospitalId, 0);
        this.date = defaultTo(params?.date?.substring(0, 10), DateTime.utc().toISO().substring(0, 10)); // trim off any timezone offset
        this.isAdHoc = false;
        this.rowVersion = defaultTo(params?.rowVersion, '');
    }
}
